import Button from '../../../components/Button/Button';
import kisanServed from '../../../assets/kisanServed.svg';
import serviceablePincodes from '../../../assets/villDelivered.svg';
import ordersDelivered from '../../../assets/delivery_truck_icon.webp';
import tonsOfFeedSold from '../../../assets/katteSold.svg';
import buffaloSold from '../../../assets/buffaloSold.svg';
import { useTranslation } from 'react-i18next';

type AboutUsProp = {
  sub: string;
  heading: string;
  desc: string;
  watchFilm?: boolean;
  stats: {
    kisanServed: string;
    ordersDelivered: string;
    tonsOfFeedSold: string;
    appDownloads: string;
    buffaloSold: string;
    serviceablePincodes: string;
  };
};

function AboutUs({ sub, heading, desc, watchFilm, stats }: AboutUsProp) {
  let { t } = useTranslation();
  let statsInfo = [
    {
      id: 'kisanServed',
      iconPath: kisanServed,
      text: 'kisan_served',
    },
    {
      id: 'ordersDelivered',
      iconPath: ordersDelivered,
      text: 'orders_delivered',
    },
    {
      id: 'tonsOfFeedSold',
      iconPath: tonsOfFeedSold,
      text: 'tons_of_feed_sold',
    },
    {
      id: 'serviceablePincodes',
      iconPath: serviceablePincodes,
      text: 'serviceable_pincodes',
    },
  ];

  let StatsCard = (data: { id: string; iconPath: string; text: string, key: number }) => {
    return (
      <div className="about_us__card" key={data.key}>
        <img
          src={data.iconPath}
          alt="Download"
          className="about_us__card--icon"
        />
        <p className="about_us__card--text">{t(data.text)}</p>
        <p className="about_us__card--number green">
          {data.id === 'kisanServed' && stats['kisanServed']}
          {data.id === 'tonsOfFeedSold' && stats['tonsOfFeedSold']}
          {data.id === 'serviceablePincodes' && stats['serviceablePincodes']}
          {data.id === 'ordersDelivered' && stats['ordersDelivered']}
        </p>
      </div>
    );
  };

  return (
    <>
      <section className="about_us">
        <div className="about_us__container">
          <div className="about_us__content">
            <p className="subheading white">{sub}</p>
            <p className="heading white">{heading}</p>

            <p className="about_us__para white">{desc}</p>
            {watchFilm ? (
              ''
            ) : (
              <Button
                outline
                text={t('know_more')}
                rightArrow
                color="#ffffff"
                to="/about-us"
              />
            )}
          </div>
          <div className="about_us__media">
            {/* <img src={whoRV} alt="" /> */}

            <iframe
              width="100%"
              height="100%"
              src="https://www.youtube.com/embed/ZQaZuRhPan4"
              title="Mission Video"
            ></iframe>
          </div>
        </div>
      </section>
      <div className="about_us__stats">
        {statsInfo.map((stat: any, index:number) => 
        StatsCard({...stat, key: index})
        )}
      </div>
    </>
  );
}

export default AboutUs;
